import { extendTheme } from "@chakra-ui/react";
import { brandConfig } from "./brandConfig";

const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  fonts: {
    heading: brandConfig.fonts.heading,
    body: brandConfig.fonts.body,
  },
  styles: {
    global: {
      body: {
        fontFamily: brandConfig.fonts.body,
      },
      "h1, h2, h3, h4, h5, h6": {
        fontFamily: brandConfig.fonts.heading,
      },
    },
  },
  components: {
    Heading: {
      baseStyle: {
        fontFamily: brandConfig.fonts.heading,
      },
    },
    Text: {
      baseStyle: {
        fontFamily: brandConfig.fonts.body,
      },
    },
    Button: {
      baseStyle: {
        fontFamily: brandConfig.fonts.body,
      },
    },
  },
});

export default theme;
